import { render, staticRenderFns } from "./ChartWrapper.vue?vue&type=template&id=573e36f8&scoped=true&"
import script from "./ChartWrapper.vue?vue&type=script&lang=ts&"
export * from "./ChartWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ChartWrapper.vue?vue&type=style&index=0&id=573e36f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573e36f8",
  null
  
)

export default component.exports